// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SiteAdmin-AggregateStore-AggregateStoreInfo-module-container {
	border: 1px solid var(--cds-grays-gray700);
	border-radius: 3px;
	padding: 8px;
}
`, "",{"version":3,"sources":["webpack://./src/SiteAdmin/AggregateStore/AggregateStoreInfo.module.css"],"names":[],"mappings":"AAAA;CACC,0CAA0C;CAC1C,kBAAkB;CAClB,YAAY;AACb","sourcesContent":[".container {\n\tborder: 1px solid var(--cds-grays-gray700);\n\tborder-radius: 3px;\n\tpadding: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `SiteAdmin-AggregateStore-AggregateStoreInfo-module-container`
};
module.exports = ___CSS_LOADER_EXPORT___;
